import { render } from "./FollowingCompany.vue?vue&type=template&id=51222c56&scoped=true"
import script from "./FollowingCompany.vue?vue&type=script&lang=js"
export * from "./FollowingCompany.vue?vue&type=script&lang=js"

import "./FollowingCompany.vue?vue&type=style&index=0&id=51222c56&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51222c56"]])

export default __exports__